module.exports = __webpack_public_path__ + "a37442b5cbfc1e5aaa6d809066afa72b.png";